import DateStorageService from '../services/DateStorageService';

export default {
    SEASON_DATE_START: process.env.SEASON_DATE_START,
    SEASON_DATE_END: process.env.SEASON_DATE_END,

    BOOKING_BOOKING_DATE_START: DateStorageService.getBookingBookingStartDateFromStorage() || process.env.SEASON_DATE_START,
    BOOKING_BOOKING_DATE_END: DateStorageService.getBookingBookingEndDateFromStorage() || process.env.SEASON_DATE_END,

    BOOKING_ARRIVAL_DATE_START: DateStorageService.getBookingArrivalStartDateFromStorage() || process.env.SEASON_DATE_START,
    BOOKING_ARRIVAL_DATE_END: DateStorageService.getBookingArrivalEndDateFromStorage() || process.env.SEASON_DATE_END,
}



// WEBPACK FOOTER //
// ./src/config/business.js